"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentElements = void 0;
const text_field_1 = require("./fields/text_field");
const siganture_1 = require("./fields/siganture");
const initials_1 = require("./fields/initials");
const date_1 = require("./fields/date");
const checkbox_1 = require("./fields/checkbox");
const radio_buttons_1 = require("./fields/radio_buttons");
const text_1 = require("./fields/text");
const page_break_1 = require("./fields/page_break");
const paragraph_1 = require("./fields/paragraph");
const spacer_1 = require("./fields/spacer");
exports.DocumentElements = {
    TextField: text_field_1.TextFieldDocumentElement,
    Signature: siganture_1.SignatureDocumentElement,
    Initials: initials_1.InitialsDocumentElement,
    Date: date_1.DateDocumentElement,
    Checkbox: checkbox_1.CheckboxDocumentElement,
    "Radio Buttons": radio_buttons_1.RadioButtonsDocumentElement,
    Text: text_1.TextDocumentElement,
    "Page Break": page_break_1.PageBreakDocumentElement,
    Paragraph: paragraph_1.ParagraphDocumentElement,
    Spacer: spacer_1.SpacerDocumentElement,
};
